import React, { useMemo } from "react";
import { Box, Typography } from "@mui/material";
import MessageListItem from "../MessageListItem/MessageListItem";
import { IEventDetailMessages, iEventType } from "../../../../../types/eventTypes";
import { EventDetailTabsEnum } from "../../../../../constants/eventDetail";
import { isObjectEmpty } from "../../../../../helpers/common";
import { getStringsFirstLetter } from "../../../../../utils/commonUtils";
import "./MessagingContainer.scss";

interface IMessagingContainerProps {
	chat: IEventDetailMessages;
	expanded: boolean;
	eventDetail: iEventType;
	onChatClick: () => void;
}

const MessagingContainer: React.FC<IMessagingContainerProps> = ({
	expanded,
	chat,
	onChatClick,
	eventDetail,
}) => {
	const isRequest = !!eventDetail.request;

	const customerDetails = useMemo(() => {
		if (isObjectEmpty(eventDetail))
			return {
				customerFirstLastName: "",
				eventName: "",
				customerName: "",
			};
		return {
			customerFirstLastName: isRequest
				? getStringsFirstLetter(
						eventDetail.request?.customerName.split(" ")[0],
						eventDetail.request?.customerName.split(" ")[1],
					)
				: getStringsFirstLetter(eventDetail.customer?.firstName, eventDetail.customer?.lastName),
			eventName: isRequest ? eventDetail.request?.name || "" : eventDetail?.name,
			customerName: isRequest
				? eventDetail.request?.customerName || ""
				: `${eventDetail.customer?.firstName} ${eventDetail.customer?.lastName}`,
		};
	}, [eventDetail]);

	return (
		<Box className={`messagingContainer ${expanded ? "messagingContainer__expanded" : ""}`}>
			<div id={`eventDetailsTag_${EventDetailTabsEnum.Chat}`} />
			<Typography className="messagingHeaderTitle">Messaging</Typography>
			{/* Messages List Section */}
			{chat && (
				<MessageListItem
					key={chat?.vendorEventId}
					message={chat}
					onClick={onChatClick}
					{...customerDetails}
				/>
			)}
		</Box>
	);
};

export default MessagingContainer;
